import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import {InputTextModule, ButtonModule, GrowlModule, InputSwitchModule} from 'primeng/primeng';

import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { LoginGuard } from './login.guard';
import { LoginService } from './login.service';
import { ModuleService } from './module.service';
import { LoginStatusComponent } from '../login-status/login-status.component';
import { ModulesComponent } from '../modules/modules.component';
import { SettingsComponent } from '../settings/settings.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LoginRoutingModule,
    InputTextModule,
    ButtonModule,
    GrowlModule,
    InputSwitchModule
  ],
  providers: [ LoginGuard, LoginService, ModuleService ],
  declarations: [LoginComponent, LoginStatusComponent, ModulesComponent, SettingsComponent],
  exports: [LoginStatusComponent, ModulesComponent]
})
export class LoginModule { }



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/login/login.module.ts